import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import type { IShowCommentFeature } from './show-comment-interface';
import { EventCodeType, TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { DrawerName } from '@framework/workbench/drawer/constants';

@Feature()
export class ShowCommentFeature extends BaseToolbarFeature implements IShowCommentFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public handleShowComment(): void {
        this.getAppService().viewableServiceLayer.commentManager.promise().then((commentManager) => {
            const isCommentDrawerShown = !commentManager.isCommentDrawerShown;
            commentManager.setIsCommentDrawerShown(isCommentDrawerShown);
            this.report(
                TDWActionType.VIEW_COMMENTS, EventCodeType.DOC_PPT_REVIEW_TAB_VIEW_COMMENTS,
                isCommentDrawerShown,
            );
            if (!isCommentDrawerShown) {
                (this.getAppService() as IPcEditorAppServices).editableServiceLayer
                    ?.drawerStateManager.promise().then((manager) => {
                        if (manager.openedDrawers.length > 1) {
                            manager.closeTab(DrawerName.COMMENT_DRAWER);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        });
    }

    public shouldCheck(): boolean {
        return !!this.getAppService().viewableServiceLayer.commentManager.dangerousInstance?.isCommentDrawerShown;
    }

    private report(action: string, eventcode: string, show: boolean) {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.TOOLBAR_REVIEW_TAB,
            ver3: 1,    // menu
            ver5: show ? 1 : 0,
            action,
            eventcode,
        });
    }
}
